import React, { useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link, useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderimage from "../image/placeholder.jpg";
import Loader from "./Loader";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogList } from "../redux/slice/BlogList";

export default function Blog() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { blogListData, isLoading, isError } = useSelector(
    (state) => state.BlogList
  );
  useEffect(() => {
    dispatch(fetchBlogList());
  }, [dispatch]);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1921 },
      items: 5,
      slidesToSlide: 2,
    },
    desktop: {
      breakpoint: { max: 1920, min: 1025 },
      items: 4,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 769 },
      items: 3,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1.5,
      slidesToSlide: 1,
    },
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Carousel
          responsive={responsive}
          swipeable={true}
          draggable={true}
          infinite={false}
          showDots={false}
          autoPlay={false}
          autoPlaySpeed={3000}
          removeArrowOnDeviceType={["mobile"]}
        >
          {blogListData.map((blogData) => {
            return (
              <Link
                to={`/blog/${blogData.slug}`}
                className="text-decoration-none"
                key={blogData.id}
              >
                <div className="blog-card-slider">
                  <div className="card border-0 blog-card">
                    <LazyLoadImage
                      src={blogData.image}
                      placeholderSrc={placeholderimage}
                      loading="lazy"
                      className="gym-pic"
                    />
                    <div className="card-body">
                      <p className="blog-txt">{blogData.title}</p>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </Carousel>
      )}
    </>
  );
}
